export interface Milestone {
  id: string;
  year: string;
  title: string;
  description: string;
  icon: string;
  category: 'founding' | 'service' | 'achievement' | 'project' | 'expansion';
  highlight?: boolean;
  createdAt: string;
}

export const mockMilestones: Milestone[] = [
  {
    id: 'ms-001',
    year: '2004',
    title: 'Zobu Consulting Founded',
    description: 'Established by Hakan Zobu as an independent management consultancy firm in Turkey. The firm was built on the principle of being "impartially on your side" — providing objective, conflict-free advisory to clients across all sectors.',
    icon: 'ri-building-2-line',
    category: 'founding',
    highlight: true,
    createdAt: '2004-01-01',
  },
  {
    id: 'ms-002',
    year: '2005',
    title: 'Management Consultancy Practice Launches',
    description: 'First significant engagements in competitive intelligence, strategic planning and organizational development. Began applying Sun Tzu-inspired competitive strategy methodology to Turkish businesses.',
    icon: 'ri-line-chart-line',
    category: 'service',
    highlight: false,
    createdAt: '2005-01-01',
  },
  {
    id: 'ms-003',
    year: '2007',
    title: 'Policy Development Advisory',
    description: 'Expanded service portfolio to include economic development policy advisory for public bodies and regional development agencies. Developed unique approach to place-based industrial strategy beyond traditional business attraction models.',
    icon: 'ri-government-line',
    category: 'service',
    highlight: false,
    createdAt: '2007-01-01',
  },
  {
    id: 'ms-004',
    year: '2009',
    title: 'Engineering Consultancy Division',
    description: 'Launched engineering advisory services covering feasibility studies, cost estimation, and risk & hazard analysis. Expanded expertise to earthquake engineering, civil, industrial and mechanical disciplines.',
    icon: 'ri-tools-line',
    category: 'service',
    highlight: false,
    createdAt: '2009-01-01',
  },
  {
    id: 'ms-005',
    year: '2012',
    title: 'International Project Portfolio',
    description: 'Expanded project reach beyond Turkey to international clients, particularly in the MENA region and Europe. Began advising multinational corporations and international development organizations.',
    icon: 'ri-global-line',
    category: 'expansion',
    highlight: false,
    createdAt: '2012-01-01',
  },
  {
    id: 'ms-006',
    year: '2014',
    title: 'CMC Certification — 10 Years of Excellence',
    description: 'Hakan Zobu maintained his Certified Management Consultant (CMC) status — the highest global standard in management consulting. Marked ten years of delivering measurable client value.',
    icon: 'ri-medal-line',
    category: 'achievement',
    highlight: true,
    createdAt: '2014-01-01',
  },
  {
    id: 'ms-007',
    year: '2015',
    title: 'GLG Scholar Recognition',
    description: 'Hakan Zobu was recognized as a GLG (Gerson Lehrman Group) Scholar, joining an exclusive global network of subject-matter experts consulted by the world\'s leading investment funds and corporations.',
    icon: 'ri-award-line',
    category: 'achievement',
    highlight: false,
    createdAt: '2015-01-01',
  },
  {
    id: 'ms-008',
    year: '2018',
    title: 'Regional Development Strategy Leadership',
    description: 'Led comprehensive regional economic development strategy projects for Turkish development agencies, introducing innovative cluster-based approaches and EU cohesion policy alignment methodologies.',
    icon: 'ri-map-2-line',
    category: 'project',
    highlight: false,
    createdAt: '2018-01-01',
  },
  {
    id: 'ms-009',
    year: '2022',
    title: 'Corporate Profile Renewal',
    description: 'Comprehensive update of firm capabilities, service portfolio and strategic positioning. Launched updated corporate identity reflecting 18 years of expertise and broadened multi-disciplinary consultancy offering.',
    icon: 'ri-refresh-line',
    category: 'achievement',
    highlight: false,
    createdAt: '2022-01-01',
  },
  {
    id: 'ms-010',
    year: '2024',
    title: 'Two Decades of Consulting Excellence',
    description: 'Celebrating 20 years of providing expert management, policy and engineering consultancy. With over 100 completed projects across Turkey and internationally, Zobu Consulting enters its third decade with expanded capabilities and a growing team.',
    icon: 'ri-star-line',
    category: 'achievement',
    highlight: true,
    createdAt: '2024-01-01',
  },
];
